import React from 'react'
import {CardBox, CardTitle, Divider} from '../BaseCard/styles'
import QuizIcon from '../../../../images/icons/new-dashboard/quiz-icon.svg'
import VideoIcon from '../../../../images/icons/new-dashboard/video-icon.svg'
import FlashcardIcon from '../../../../images/icons/new-dashboard/flashcard-icon.svg'
import ExamIcon from '../../../../images/icons/new-dashboard/exam-icon.svg'
import {StudyGuide} from '../../../../redux/studyGuides'
import {
  PercentageText,
  ProgressBox,
  ScoreText,
  StatsBox,
  StatsItem,
  StatsPercentage,
  StatsTitle,
} from './styles'
import {LinearProgress} from '@mui/material'

type Props = {
  studyGuide?: StudyGuide
}

const View = ({studyGuide}: Props) => {
  return (
    <CardBox>
      <CardTitle>
        <span>Your scores</span>
      </CardTitle>
      <Divider />
      <StatsBox>
        <StatsItem>
          <StatsTitle>
            <img src={VideoIcon} alt="Video" /> Videos
          </StatsTitle>
          <StatsPercentage>
            <ScoreText>Watched</ScoreText>
            <ProgressBox>
              <LinearProgress
                variant="determinate"
                value={studyGuide?.percentageVideosWatched ?? 0}
              />
            </ProgressBox>
            <PercentageText>
              {studyGuide?.percentageVideosWatched ?? 0}%
            </PercentageText>
          </StatsPercentage>
        </StatsItem>

        <StatsItem>
          <StatsTitle>
            <img src={QuizIcon} alt="Quiz" /> Quizzes
          </StatsTitle>
          <StatsPercentage>
            <ScoreText>Average</ScoreText>
            <ProgressBox>
              <LinearProgress
                variant="determinate"
                value={studyGuide?.averageQuizScore ?? 0}
              />
            </ProgressBox>
            <PercentageText>
              {studyGuide?.averageQuizScore ?? 0}%
            </PercentageText>
          </StatsPercentage>
        </StatsItem>

        <StatsItem>
          <StatsTitle>
            <img src={ExamIcon} alt="Practice Exams" /> Practice Exams
          </StatsTitle>
          <StatsPercentage>
            <ScoreText>Best Score</ScoreText>
            <ProgressBox>
              <LinearProgress
                variant="determinate"
                value={studyGuide?.examBestScore ?? 0}
              />
            </ProgressBox>
            <PercentageText>{studyGuide?.examBestScore ?? 0}%</PercentageText>
          </StatsPercentage>
        </StatsItem>

        <StatsItem>
          <StatsTitle>
            <img src={FlashcardIcon} alt="Flashcards" /> Flashcards
          </StatsTitle>
          <StatsPercentage>
            <ScoreText>Mastered</ScoreText>
            <ProgressBox>
              <LinearProgress
                variant="determinate"
                value={studyGuide?.percentageFlashcardsMastered ?? 0}
              />
            </ProgressBox>
            <PercentageText>
              {studyGuide?.percentageFlashcardsMastered ?? 0}%
            </PercentageText>
          </StatsPercentage>
        </StatsItem>
      </StatsBox>
    </CardBox>
  )
}

export default View
